import axios from './../../api';
import store from './../../store';
import Permissions from '../../mixins/PermissionsHelpers.vue';
import Constants from './../../constants';

export default {
  namespaced: true,

  state: {
    roles:[],
    roleToEdit: {},
    isNewRole: false,

  },
  getters:{
    roles(state){
      return state.roles;
    },

    roleToEdit(state){
      return state.roleToEdit;
    },
    isNewRole(state) {
      return state.isNewRole;
    }
  },
  mutations: {
    SET_ROLES(state, r){
      state.roles = r;
    },

    SET_ROLETOEDIT(state, role){
      //in case new role
      if(role.id == null){
        state.roleToEdit = JSON.parse(JSON.stringify(role));
      }
      //in case existing role to edit
      if(role.id != null){
        if(role.typeAction == 'edit'){
          axios.get('api/roles/'+role.id).then((response)=>{
            state.roleToEdit = response.data;
          });
        }
        if(role.typeAction == 'delete'){
          state.roleToEdit = JSON.parse(JSON.stringify(role));
        }
      }
    },
    SET_ISNEWROLE(state, newrole) {
      state.isNewRole = newrole;
    }
  },
  actions:{    
    /**
         * load all roles created in current company
         * @param {*} context 
         */
    async loadRoles(context){
      console.log('wait...loading roles');

      await axios.get('api/roles').then((response) => {
        context.commit('SET_ROLES', response.data);
      });
    },

    /**
         * Save (modify or create) a role and all permissions in current company (id role is in newRole)
         * @param {*} context 
         */
    async saveRole(context) {
      console.log('edit save role');
      let isNewRole = false;
      if(context.getters.roleToEdit.id == null){
        isNewRole = true;
      }

      if((
        isNewRole 
                    && Permissions.methods.$can(Constants.PERMISSION_GESTION_DROITS_ROLE_AJOUTER)
      ) 
                || (!isNewRole && Permissions.methods.$can(Constants.PERMISSION_GESTION_DROITS_ROLE_EDITER))
      ){
        store.commit('permissions/SET_SAVING', true);
                
        await axios.post('/api/roles', context.getters.roleToEdit).then((response) => {
          context.getters.roleToEdit.id = response.data;
                    
          store.commit('permissions/SET_MESSAGEHEADER', 
            isNewRole ? {type: 'success', msg: 'Le rôle '+context.getters.roleToEdit.name+' a bien été créé.'}
              : {type: 'success', msg: 'Le rôle '+context.getters.roleToEdit.name+' a bien été modifié.'}
          );
                    
          context.dispatch('loadRoles'); //reload roles list
                    
          store.dispatch('referents/loadReferents'); //reload referent list to update roles name
          store.commit('permissions/SET_SAVING', false);

          setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);
          store.commit('permissions/SET_ERRORS', []);
        })
          .catch(error => {
            store.commit('permissions/SET_MESSAGEHEADER', {type: 'error', msg: 'Erreur d\'enregistrement des données.'});
            setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);
        
            console.log('ERRRR:: ', error.response.data.errors);
            store.commit('permissions/SET_ERRORS', error.response.data.errors);
            store.commit('permissions/SET_SAVING', false);
          });
      }
    },

    /**
         * delete the role by id
         * @param {*} context 
         * @param int id 
         */
    async deleteRole(context){
      store.commit('permissions/SET_SAVING', true);
            
      let id = context.getters.roleToEdit.id;
      let res = '';

      await axios.delete('/api/roles/'+id).then((response) => {
        res = response.data;
        if(response.data == 'ok'){
          context.dispatch('loadRoles');
        }
        store.commit('permissions/SET_SAVING', false);
      }).catch(error => {
        console.log('ERRRR:: ', error.response.data);
      });
      return res;
    },
  },
};